import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';

const NormalNotice = ({ loadNotice }) => {
    const { notices } = useSelector((state) => state.notices)

    if (!loadNotice || notices.length === 0) {
        return (
            <div className="notice-empty">
                <i className="fa-solid fa-inbox"></i>
                <p>No notices to display at the moment.</p>
            </div>
        )
    }

    return (
        <Swiper
            slidesPerView={1}
            spaceBetween={20}
            loop={true}
            autoplay={{ delay: 3500, disableOnInteraction: false, pauseOnMouseEnter: true }}
            pagination={{ clickable: true, dynamicBullets: true }}
            breakpoints={{
                576:  { slidesPerView: 2, spaceBetween: 20 },
                992:  { slidesPerView: 3, spaceBetween: 24 },
                1280: { slidesPerView: 4, spaceBetween: 24 },
            }}
            modules={[Autoplay, Pagination]}
            className="notice-swiper"
        >
            {notices.map((notice, index) => index < 8 && (
                <SwiperSlide key={notice.id}>
                    <div className="notice-card">

                        {/* Coloured top accent bar */}
                        <div className="notice-card-accent"></div>

                        {/* Date badge */}
                        <div className="notice-card-date-badge">
                            <span className="notice-day">
                                {moment(notice.publisheddate, 'DD-MMM-YYYY hh:mm A').format('DD')}
                            </span>
                            <span className="notice-mon">
                                {moment(notice.publisheddate, 'DD-MMM-YYYY hh:mm A').format('MMM')}
                            </span>
                            <span className="notice-yr">
                                {moment(notice.publisheddate, 'DD-MMM-YYYY hh:mm A').format('YYYY')}
                            </span>
                        </div>

                        {/* Body */}
                        <div className="notice-card-body">
                            <div className="notice-card-icon-wrap">
                                <i className="fa-solid fa-scroll"></i>
                            </div>
                            <h5 className="notice-card-title">
                                {notice.subject.length > 65
                                    ? notice.subject.substring(0, 65) + '…'
                                    : notice.subject}
                            </h5>
                            <p className="notice-card-meta">
                                <i className="fa-regular fa-clock"></i>
                                {notice.publishedago}
                            </p>
                        </div>

                        {/* Footer */}
                        <div className="notice-card-footer">
                            <Link to={'/notice/' + notice.id} className="notice-card-btn">
                                Read Notice <i className="fa-solid fa-arrow-right"></i>
                            </Link>
                        </div>

                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default NormalNotice
